import UseCasesIcon from '@icons/UseCasesIcon.svg';
import RetentionIcon from '@icons/RetentionIcon.svg';
import TrendingIcon from '@icons/trend.svg';
import EfficiencyIcon from '@icons/EfficientIcon.svg';
import type { UseCasesWhyHowBlock } from '@components/widgets';

export const TPAS_USE_CASES_WHY_HOW_SECTION_TITLE =
    'Why Predictable Benefits for Third Party Administrators';

export const TPAS_USE_CASES_WHY_HOW_BLOCKS: UseCasesWhyHowBlock[] = [
    {
        pillNavLabel: 'Claims Automation',
        title: 'Eliminating the "Manual Claim" Bottleneck',
        description:
            'Standard HRA administration for ICHRA is a nightmare if employees have to manually upload individual premium receipts every month.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'Predictable Benefits automates the verification of individual coverage. The platform syncs with carriers to confirm the policy is active, meaning your team doesnt have to manually audit 1,000 different paper receipts to ensure a reimbursement is tax-compliant.',
            },
            {
                iconSrc: EfficiencyIcon,
                title: 'Efficiency Impact',
                description:
                    'Scales your ICHRA book of business without needing to hire a massive team of claims processors.',
            },
        ],
    },
    {
        pillNavLabel: 'Protect Ancillary Revenue',
        title: 'Protecting the "Ancillary" Spend (FSAs & HSAs)',
        description:
            'When an employer moves to an ICHRA platform owned by a competitor (like a specialized ICHRA startup), that competitor will try to take the HSA and FSA business away from you.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'By owning the ICHRA platform via white-labeling, you keep the employer inside your ecosystem.',
            },
            {
                iconSrc: RetentionIcon,
                title: 'Retention Impact',
                description:
                    'You "lock the back door." The ICHRA becomes the anchor that keeps the FSA, HSA, and COBRA business with you for the long term.',
            },
        ],
    },
    {
        pillNavLabel: 'Broker Enablement',
        title: 'Solving the "Broker Gap"',
        description:
            'Brokers love the idea of ICHRA but hate the logistics of helping employees pick individual plans. They look to their TPA/Administrator for a solution.',
        cards: [
            {
                iconSrc: UseCasesIcon,
                title: 'The Use Case',
                description:
                    'You give your brokers a white-labeled portal where their clients’ employees can shop for plans in minutes.',
            },
            {
                iconSrc: TrendingIcon,
                title: 'Growth Impact',
                description:
                    'You become the "Preferred Admin" for every broker in your network because you solved their biggest headache: the shopping experience.',
            },
        ],
    },
];
